import React, { FunctionComponent, useState } from 'react';
import withStyles from 'react-jss';
import { Redirect } from 'react-router-dom';
import classnames from 'classnames';
import { Confirm } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';
import { Theme } from 'config';

const styles = (theme: Theme) => ({
  link: {
    margin: '.5rem .375rem',
    backgroundColor: theme.violet,
    borderRadius: '1.5rem',
    color: '#fff',
    fontSize: '.8rem',
    padding: '0.4rem 0.75rem',
    fontWeight: '500',
    lineHeight: '1.25rem',
    cursor: 'pointer',

    '&.disabled': {
      cursor: 'default !important',
      backgroundColor: `${theme.btnGray} !important`,
      '&:hover': {
        opacity: '1 !important',
      },
    },
  },
  '@global .modal .actions *': {
    fontSize: '0.8em !important',
  },
  '@global .modal .actions .ui.primary.button': {
    backgroundColor: `${theme.violet} !important`,
  },
});

type Props = {
  classes: ClassProp<ReturnType<typeof styles>>;
  content: string;

  className?: string;
  to?: any;
  redirect?: boolean;
  disabled?: boolean;
  onConfirmed?: Function;
};

const LinkConfirm: FunctionComponent<Props> = ({
  classes,
  className,
  to,
  children,
  content,
  redirect = false,
  disabled = false,
  onConfirmed,
}) => {
  const [redirectAction, setRedirect] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);

  const onConfirm = () => {
    if (onConfirmed) {
      onConfirmed();
    }

    setOpen(false);
    setRedirect(redirect);
  };

  const onClick = () => {
    if (disabled) return;
    setOpen((state: boolean) => !state);
  };

  if (redirectAction) {
    return <Redirect push to={to} />;
  }

  return (
    <>
      <Confirm
        content={content}
        size="tiny"
        open={open}
        onClose={onClick}
        onCancel={onClick}
        onConfirm={onConfirm}
      />

      <div
        onClick={onClick}
        className={classnames(className, classes.link, { disabled })}
      >
        {children}
      </div>
    </>
  );
};

export default withStyles(styles)(LinkConfirm);
